<template lang="pug">
index-page(
  @set-loading="setLoading",
  :parentData="{ grid, path, grid_key, transition_key, report_class, report_namespace, headerFiltersGroupClass: 'col-5 no-padding' }"
)
</template>

<script>
import indexPage from "../../../shared/indexPage";

export default {
  components: {
    indexPage,
  },
  data: function () {
    return {
      grid: "ppr_work_groups",
      report_class: "work_group",
      report_namespace: "ppr",
      path: this.$store.state.paths["ppr_work_group"],
      transition_key: "ppr_work_group",
      grid_key: "data",
    };
  },

  beforeMount() {
    this.$emit("expand-class", { val: false, class: "" });
  },

  methods: {
    setLoading(val) {
      this.$emit("set-loading", val);
    },
  },
};
</script>

<style lang="scss"></style>
